const CommonR = [
  {
    path: '/clause/index',
    name: 'clause20210320',
    component: resolve => require(['@/clause/index'], resolve),
    meta: {
      title: '电源网服务条款'
    }
  }

]

export default CommonR
